import React, { Component } from 'react';
import axios from 'axios'
import { Buffer } from 'buffer';
import { Card, Row, Button, Col } from 'react-bootstrap';
import OrderCompleted from '../components/orderCompeted';
import { connect } from 'react-redux';
import { orderStatus } from '../utils';
import { withRouter } from "react-router-dom";
import Pagination from "../components/pagination"

class Orders extends Component {
    state = {
        jobs: [],
        imageSrcArray: {},
        show: "ordered",
        currentPage: 1,
        queriedCount: 0,
    }

    componentDidMount() {
        this.getJobs()
    }
    getJobs = () => {
        this.getOrdersByQuery()
    }
    getOrdersByQuery = () => {
        axios.post("/api/jobs/get/count/by/query", { showFilter: this.state.show }).then(res => {
            this.setState({ queriedCount: res.data.count}, () => {
                axios.post("/api/jobs/user", { show: this.state.show , page: this.state.currentPage - 1, count: 10 }).then(res => {
                    if (res.data.success) {
                        this.setState({ jobs: res.data.jobs })
                    }
                })
            })
        })
    }

    getModelImage = async (job) => {

        if (!job.model) {
            return
        }
        let res = await axios.post('/api/model/image/by/filename', { job: job._id, }, { responseType: 'arraybuffer' }).then(res => {
            const base64 = Buffer.from(res.data, 'binary').toString('base64');
            const contentType = res.headers['content-type'] || 'image/png'; // fallback to PNG
            const imageSrc = `data:${contentType};base64,${base64}`;
            this.setState({
                imageSrcArray: {
                    ...this.state.imageSrcArray,
                    [job.model]: imageSrc
                }
            });
        }).catch(err => {

        })
    }
    changeShow = (type) => {
        this.setState({ show: type }, () => this.getJobs())
    }
    reorderById = (id) => {
        axios.post("/api/jobs/reorder/by/id", { id: id }).then((res) => {
            this.props.history.push("/print?job-id=" + res.data.jobId)
        })
    }
    changePage = (page) => {
        this.setState({ currentPage: page }, () => {
            this.getOrdersByQuery()
        })
    }
    render() {
        let jobs = []
        let darkmode = this.props.user ? this.props.user.darkmode : true
        let pages = Math.ceil(this.state.queriedCount / 10)

        for (let job of this.state.jobs) {
            if (!this.state.imageSrcArray[job.model]) {
                this.getModelImage(job)
            }
            jobs.push(
                <Card className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ margin: "20px", padding: "20px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ flex: "0 0 auto", marginRight: "20px" }}>
                            <img style={{ width: "200px" }} src={this.state.imageSrcArray[job.model]} alt="Model" className="mt-4 border rounded" />
                        </div>
                        <div style={{ flex: 1 }}>
                            <p>
                                Model: {job.originalFileName}
                            </p>
                            <p>
                                Filament: {job.filament}
                            </p>
                            <p>
                                Payment Status: {job.paymentStatus}
                            </p>
                            <p>
                                Price: £{job.price}
                            </p>
                            <p>
                                Print Status: {orderStatus[job.printStatus]}
                            </p>
                            <p>
                                Shipping: {job.shipping ? job.shipping : "None Selected"}
                            </p>
                            {this.state.show == "draft" &&
                                <button onClick={() => this.props.history.push("/print?job-id=" + job._id)}>
                                    Continue
                                </button>
                            }
                            {this.state.show == "quote_ready" &&
                                <button onClick={() => this.props.history.push("/print?job-id=" + job._id)}>
                                    Continue
                                </button>
                            }
                            {this.state.show == "ordered" && <div>
                                <Row style={{ margin: "auto", margin: "20px" }}>
                                    <Col style={{ margin: "auto" }}>
                                        <Button onClick={() => this.reorderById(job._id)}>Reorder</Button>
                                    </Col>
                                </Row>
                                <Row style={{ margin: "auto", margin: "20px" }}>
                                    <Col style={{ margin: "auto" }}>
                                        <Button style={{ width: "100%" }} target="_blank" href={job.invoice_url}>Invoice</Button>
                                    </Col>
                                </Row>
                            </div>

                            }


                        </div>
                    </div>


                </Card>


            )
        }

        return (
            <div style={{ width: "100%", margin: "auto", textAlign: "center", maxWidth: "1000px" }}>
                <OrderCompleted />
                <Row>
                    <Col>
                        <Button active={this.state.show == "ordered"} onClick={() => this.changeShow("ordered")}>Ordered</Button>

                    </Col>
                    <Col>
                        <Button active={this.state.show == "quote_ready"} onClick={() => this.changeShow("quote_ready")}>Quote Ready</Button>
                    </Col>
                    <Col>
                        <Button active={this.state.show == "draft"} onClick={() => this.changeShow("draft")}>Draft</Button>
                    </Col>
                </Row>
                {this.state.show == "quote_ready" &&
                    <Card className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ margin: "20px", padding: "20px" }}>
                        Quoted orders will be deleted one month after creation unless purchased.
                    </Card>
                }
                {this.state.show == "draft" &&
                    <Card className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ margin: "20px", padding: "20px" }}>
                        Draft orders will be deleted one week after creation unless a quote is created.
                    </Card>
                }
                {jobs}
                <Card className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ margin: "20px", padding: "20px" }}>
                    <Pagination changePage={this.changePage} currentPage={this.state.currentPage} pages={pages} />
                </Card>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Orders));